import React from "react"
import LazyLoader from "utils/LazyLoading"

export default function ReactFilestackLazy(props) {
    return (
        <LazyLoader
            getModule={() => import("filestack-react")}
            children={({ default: Component }) => <Component {...props} />}
        />
    )
}



// WEBPACK FOOTER //
// ./src/lazyComponents/ReactFilestack.js